import "./winnerSuperbowl.sass";
import defaultWinner from '../../../assets/ganador.png';


export default function WinnerSuperbowl({ winnerTeam }) {
  return (
    <div className="winner-superbowl-container">
      <div className="winner-superbowl-circle">
        {winnerTeam != null ? (
          <img src={winnerTeam.logo} alt={winnerTeam.name ? winnerTeam.name : "team name"} className="winner-superbowl-logo" />
        ) : (
          <img className="winner-superbowl-text" src={defaultWinner} alt="winner-superbowls" />
        )}
      </div>
    </div>
  );
}
